export function looksLikePlainUrl(value: unknown): boolean {
  if (typeof value !== 'string') return false
  return /^https?:\/\//i.test(value.trim())
}

export function buildPlainUrlAnchorHtml(url: string): string {
  const trimmed = url.trim()
  const escaped = trimmed
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
  return `<p><a href="${escaped}" target="_blank" rel="noopener noreferrer">${escaped}</a></p>`
}
